import type { FaireProductEntity } from "../../entity_types/product";

export const p_aa7ex4avg2: FaireProductEntity = {
  token: "p_aa7ex4avg2",
  type: "product",
  name: "Natural Snow Quartz Rabbit Bunny Healing Energy 5cm",
  brandToken: "b_edj9u7j4sq",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/11cdfe1c8922edf54cf0f34c4afb4b1b44a54ca7722c987ab3ac53c80936192f.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/a22f62d6663b1fc5d0ce9d92d5692a838deb6b84582a07c8b7731793cb310509.jpeg",
    "https://cdn.faire.com/fastly/678438fe2d41b074ef42ebd8d2f4b9c5577eb02adf09e490f3d718d641cb631e.jpeg",
    "https://cdn.faire.com/fastly/5ad05b26d6949d06029c75f0a1bf57b4c1b2ab335117f583fd2512996527d4dc.jpeg",
    "https://cdn.faire.com/fastly/fcaf52942186c2d8b144ce92aa3636ce1da487e22a5bb9047438d0353d51023e.jpeg",
    "https://cdn.faire.com/fastly/484ee36e7458b483d2427fe2cd8a3ae019bbaafbcfb64407e7b16578f27996d7.jpeg",
  ],
  priceDollars: 9.54,
  description:
    "Enhance your crystal collection with these charming Natural Snow Quartz Rabbit Bunnies. Each bunny is beautifully hand-crafted, measuring approximately 5 cm in size. These adorable carvings feature natural black obsidian eyes, creating a striking contrast against the soft, milky white quartz for added visual appeal.\n\nThe ears have been color-enhanced to give each piece a unique and eye-catching look, making them perfect for retail display, gift sets, or seasonal offerings like Easter.\n\nWith a total lot weight ranging between 1 lb to 1.3 lbs, you’ll receive a well-balanced assortment that’s ideal for resale and easy merchandising.\n\nCondition is New. \nMinimum order 8 pieces \n\nLocal pickup is available in Brooklyn, New York. \n\nStones, stone, crystal, crystals, crystals bulk, crystals wholesale, spiritual, spiritual items, meditation, metaphysical wholesale.",
  tags: [],
  msrpDollars: 19.07,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:25:08.311Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
